<template>
    <header class="header">
        <nav class="navbar">
            <div class="container-fluid">
                <div class="d-flex align-items-center justify-content-between w-100">
                    <div class="d-flex align-items-center">
                        <button v-if="!isActive('UnidadesPage') && !isActive('ConsultaAvancadaPage')" @click="toggleSidebar" class="menu-btn d-flex align-items-center justify-content-center p-2 bg-gray-900" id="toggle-btn">
                            <div class="group-line">
                                <div class="line"></div>
                                <div class="line"></div>
                                <div class="line"></div>
                            </div>
                        </button>
                        <a class="navbar-brand ms-2">
                            <div class="d-flex align-items-center brand-text text-uppercase letter-spacing-0">
                                <span class="text-white fw-normal text-xs"></span>
                                <strong
                                    class="text-primary text-sm text-vue-app">{{ vue_app_name }}</strong>
                            </div>
                        </a>
                    </div>
                    <ul class="nav-menu mb-0 list-unstyled d-flex flex-md-row align-items-md-center">
                        <li v-if="!isActive('UnidadesPage') && !isActive('ConsultaAvancadaPage')" class="nav-item dropdown">
                            <a 
                                class="nav-link dropdown-toggle text-branco text-sm text-uppercase" 
                                id="usuario_nav" href="#" 
                                data-bs-toggle="dropdown" 
                                aria-haspopup="true" 
                                aria-expanded="false"
                                >
                                {{ unidadeAtual.nome }}
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end mt-sm-3 shadow-sm" style="max-height: 30vh; overflow-y: auto;">
                                <router-link class="dropdown-item text-uppercase" :to="'/v1/unidades/'">
                                <i class="fa-solid fa-house"></i>
                                    Minhas Unidades
                                </router-link>
                                <router-link v-for="unidade in activeUnidades" :key="unidade.id" class="dropdown-item text-uppercase" :to="'/v1/unidades/' + unidade.id">
                                        {{unidade.nome}}
                                </router-link>
                            </ul>
                        </li>
                        &nbsp;
                        &nbsp;
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle text-branco text-sm" id="usuario_nav" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Usuario: {{ this.user ? this.user.nome : '' }}
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end mt-sm-3 shadow-sm" aria-labelledby="usuario_nav">
                                <li class="dropdown-item">
                                    <router-link class="minhaconta nav-link text-sm ps-0 w-100 text-start" :to="'/minha-conta'">
                                        <i class="fa-solid fa-user"></i>
                                        &nbsp; Minha Conta
                                    </router-link>
                                </li>                              
                                <li class="dropdown-item">
                                    <button class="button-logout text-sm ps-0 w-100 text-start" @click="authLogout">
                                        <i class="fa-solid fa-right-from-bracket"></i>
                                        <span class="d-none d-sm-inline-block">&nbsp; Sair</span>
                                    </button>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
import { mapActions, mapGetters, useStore } from 'vuex';
import { watch, ref, onMounted } from 'vue';

export default {
    setup () {
        const vue_app_name = process.env.VUE_APP_NAME;
        const version = process.env.VUE_APP_VERSION;
        const store = useStore();
        const unidades = ref([]);
        const unidadeAtual = ref({});

        onMounted(async () => {
            try {
                unidades.value = store.state.unidades.unidades;
                if (unidades.value.length == 0) {
                    await store.dispatch("unidades/fetchUnidades");
                    unidades.value = store.state.unidades.unidades;
                }
                
            } catch (error) {
                console.error("Erro ao buscar unidades:", error);
            }
        });

        watch(() => store.state.unidade.unidade, (newUnidade) => {
				unidadeAtual.value = newUnidade;
			}, { immediate: true }
		);

        return {
            vue_app_name,
            version,
            unidades,
            unidadeAtual
        }
    },
    data() {
        return {
            showDropdown: false
        };
    },
    computed: {
        ...mapGetters('auth', ['getUser']),
        user() {
            return this.getUser;
        },
        activeUnidades() {
            return this.unidades.filter(unidade => unidade.status === 'ativo');
        }
    },
    methods: {
        ...mapActions('auth', ['logout']),
        ...mapActions('ui', ['toggleSidebar']),
        async authLogout() {
            try {
                await this.logout();
                this.$router.push('/login');
            } catch (error) {
                console.error('Erro ao fazer logout:', error);
            }
        },
        isActive(route) {
            return this.$route.name === route || this.$route.path.includes(route);
        },
        navigateTo(unidadeId) {
            this.$router.push(`/v1/unidades/${unidadeId}`);
        }
    }
}
</script>

<style scoped>
    .navbar {
        z-index: 1000;
    }
    .margin-r {
        margin-right: 10px;
    }

    .text-primary {
    color: #33b35a !important;
    }
    .menu-btn {
        width: 4vh;
        height: 4vh;
        border-radius: 0px !important;
        border: 0px;
    }
    .line {
        padding: 1px;
        width: 20px;
        height: 1px;
        background-color: #fff;
        margin: 5px;
    }

    .text-branco {
        color: #fff;
    }

    .nav-link:hover {
    color: #33b35a;
    }

    .minhaconta:hover {
    color: black;
    }

    .button-logout:active {
        background-color: #33b35a;
    }

    .dropdown-item:hover {
        background-color: #33b35a;
    }
    .navbar-brand{
        align-self: center;
    }
    .text-primary{
        align-items: center;
    }

    @media (max-width: 768px) {
        .text-vue-app {
            display: none;
        }
    }

</style>
